import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 56

/**
 * Circle shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const CircleShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default CircleShape
